import React from "react";
import "./App.css";
import styled from "styled-components";
import Calendar from "./Calendar";

function App() {
  return (
    <div className="App">
      <Calendar></Calendar>
    </div>
  );
}

export default App;
